/* NOOT — Urgency Box. Real stock per selected size + real offer countdown. No fake numbers. */
if (!customElements.get('urgency-box')) {
  customElements.define(
    'urgency-box',
    class UrgencyBox extends HTMLElement {
      connectedCallback() {
        try {
          this.variants = JSON.parse(this.querySelector('[data-urgency-variants]').textContent);
        } catch (e) {
          this.variants = {};
        }
        this.threshold = parseInt(this.dataset.threshold, 10) || 5;
        this.barScale = parseInt(this.dataset.barScale, 10) || 10;
        this.stock = this.querySelector('[data-urgency-stock]');
        this.titleEl = this.querySelector('[data-urgency-title]');
        this.fill = this.querySelector('[data-urgency-fill]');
        this.offer = this.querySelector('[data-urgency-offer]');
        this.countdown = this.querySelector('[data-urgency-countdown]');

        const info = this.closest('product-info');
        this.sectionId = info ? info.dataset.section : null;

        // Dawn updates the hidden variant input and fires "change" when a size is picked
        this.onVariantInput = (event) => {
          const input = event.target;
          if (!input || input.name !== 'id') return;
          const form = this.sectionId ? input.closest(`#product-form-${this.sectionId}`) : input.closest('form');
          if (!form) return;
          this.updateStock(input.value);
        };
        document.addEventListener('change', this.onVariantInput);

        if (this.offer) {
          this.endTime = Date.parse(this.offer.dataset.end);
          this.tick();
          this.timer = setInterval(() => this.tick(), 1000);
        }
        this.refreshVisibility();
      }

      disconnectedCallback() {
        document.removeEventListener('change', this.onVariantInput);
        if (this.timer) clearInterval(this.timer);
      }

      updateStock(variantId) {
        const v = this.variants[variantId];
        const show = !!v && v.tracked && v.qty > 0 && v.qty <= this.threshold;
        if (show) {
          this.titleEl.textContent =
            v.qty === 1 ? `Hurry — last piece in ${v.label}` : `Hurry — only ${v.qty} left in ${v.label}`;
          const pct = Math.max(6, Math.min(100, Math.round((v.qty / this.barScale) * 100)));
          this.fill.style.width = `${pct}%`;
        }
        this.stock.hidden = !show;
        this.refreshVisibility();
      }

      tick() {
        const remaining = this.endTime - Date.now();
        if (!this.endTime || isNaN(this.endTime) || remaining <= 0) {
          // the offer has really ended — remove it instead of restarting
          this.offer.remove();
          this.offer = null;
          clearInterval(this.timer);
          this.refreshVisibility();
          return;
        }
        const s = Math.floor(remaining / 1000);
        const d = Math.floor(s / 86400);
        const h = Math.floor((s % 86400) / 3600);
        const m = Math.floor((s % 3600) / 60);
        const sec = s % 60;
        const pad = (n) => String(n).padStart(2, '0');
        this.countdown.textContent = d > 0 ? `${d}d ${pad(h)}h ${pad(m)}m` : `${pad(h)}:${pad(m)}:${pad(sec)}`;
      }

      refreshVisibility() {
        const stockVisible = this.stock && !this.stock.hidden;
        this.hidden = !(stockVisible || this.offer);
      }
    }
  );
}
